import { useSnackbar } from "src/utils/useSnackbar";
import { useQueryClient } from "react-query";
import { getAllActionPlanKey } from "src/api/client-api/ActionPlan/ActionPlan/useGetAllActionPlan";
import { useNavigate } from "react-router";
import { ActionPlanWrite, useUpsertActionPlan } from "src/api/client-api/ActionPlan/ActionPlan/useUpsertActionPlan";
import { useTranslation } from "react-i18next";
import { getOneActionPlanKey } from "src/api/client-api/ActionPlan/ActionPlan/useGetOneActionPlan";
import { ActionUrls } from "./provider";

type Options = {
    urls: ActionUrls;
    setSavingStatus: (newSavingState: boolean) => void;
};

export const useCreateActionPlan = (options: Options) => {
    const { urls, setSavingStatus } = options;
    const _createActionPlan = useUpsertActionPlan();
    const queryClient = useQueryClient();
    const snackbar = useSnackbar();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const createActionPlan = (data: ActionPlanWrite) => {
        setSavingStatus(true);
        _createActionPlan.mutate(
            { payload: data },
            {
                onSuccess: () => {
                    snackbar.forceClose();
                    snackbar.setSnackbarProps({
                        type: "info",
                        message: t("actionplan.snackbar.creationsuccess"),
                    });
                    const urlToGo = urls.planning();
                    queryClient.refetchQueries([getAllActionPlanKey]);
                    queryClient.refetchQueries([getOneActionPlanKey]);
                    navigate(urlToGo);
                    return;
                },
                onError: () => {
                    snackbar.forceClose();
                    snackbar.setSnackbarProps({
                        type: "info",
                        message: t("actionplan.snackbar.creationerror"),
                    });
                },
                onSettled: () => {
                    setSavingStatus(false);
                },
            },
        );
    };

    return { createActionPlan };
};
